import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-gradient-to-br from-[#2D2A3E] via-[#3A2F4A] to-[#2D2A3E] px-4 text-center relative overflow-hidden" data-id="element-64">
      <div className="absolute top-0 left-0 w-64 h-64 bg-[#C4973B]/10 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl" data-id="element-65"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#C06B6B]/10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl" data-id="element-66"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#B8A9C9]/5 rounded-full blur-3xl" data-id="element-67"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-68">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-8" data-id="element-69">
          Ahora la decisión es clara
        </h2>

        <div className="space-y-4 mb-12 text-white/90 text-lg" data-id="element-70">
          <p data-id="element-71">Puedes seguir intentando controlar tu mente.</p>
          <p className="font-bold text-white text-xl" data-id="element-72">
            O puedes enseñarle a tu cuerpo que ya está a salvo.
          </p>
          <p className="text-white/60" data-id="element-73">
            Tu sistema nervioso no necesita más información. Necesita una señal
            diferente.
          </p>
          <p className="text-[#C4973B] font-medium italic" data-id="element-74">
            Y algo dentro de ti ya sabe que esta es la señal.
          </p>
        </div>

        <div className="bg-white/5 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-[#C4973B]/20 shadow-2xl" data-id="element-75">
          {/* Price reminder */}
          <div className="mb-8" data-id="element-76">
            <p className="text-white/40 text-sm line-through mb-1" data-id="element-77">
              Antes: $47
            </p>
            <p className="text-white font-bold text-2xl" data-id="element-78">
              Hoy: $11.99 · Pago único · De por vida
            </p>
            <p className="text-sm text-[#C4973B] font-semibold mt-1" data-id="element-79">
              Ahorras $35 hoy (77% descuento)
            </p>
            <p className="text-white/50 text-sm mt-1" data-id="element-80">
              📲 Acceso inmediato después del pago · Disponible desde tu
              teléfono
            </p>
          </div>

          <p className="text-white/70 text-lg mb-8 italic" data-id="element-81">
            Si estás leyendo esto, es porque tu cuerpo está cansado de
            sobrevivir.
          </p>

          <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-gradient-to-r from-[#C4973B] to-[#D4A84C] text-white font-bold text-xl py-5 px-10 rounded-full shadow-xl shadow-[#C4973B]/30 hover:shadow-2xl hover:shadow-[#C4973B]/40 hover:scale-105 transition-all flex items-center justify-center gap-3 mx-auto group" data-id="element-82">
            👉 Quiero calmar mi ansiedad ahora
            <ArrowRight className="h-6 w-6 group-hover:translate-x-1 transition-transform" data-id="element-83" />
          </a>

          <p className="mt-6 text-sm text-white/40" data-id="element-84">
            $11.99 · Acceso inmediato · Garantía incluida
          </p>
        </div>
      </div>
    </section>;
}